import { render, staticRenderFns } from "./premiumInfo.vue?vue&type=template&id=ca52de60&scoped=true&"
import script from "./premiumInfo.vue?vue&type=script&lang=js&"
export * from "./premiumInfo.vue?vue&type=script&lang=js&"
import style0 from "./premiumInfo.vue?vue&type=style&index=0&id=ca52de60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca52de60",
  null
  
)

export default component.exports